import React, { createContext, useContext } from 'react';
import { Product, useProductsGet } from '../hooks/api/products';

interface ProductContextProps {
  data?: Product[] | null;
  loading: boolean;
  error: any;
}

const ProductContext = createContext<ProductContextProps>({
  data: null,
  loading: false,
  error: null,
});

// eslint-disable-next-line react/function-component-definition
export const ProductProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { data, loading, error } = useProductsGet();

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <ProductContext.Provider value={{ data, loading, error }}>
      {children}
    </ProductContext.Provider>
  );
};

export const useProductContext = () => useContext(ProductContext);
